module.exports = __webpack_public_path__ + "media/1alB-u-gu.9d6ff2fe.mp3";